import React, {useContext, useEffect} from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {setUiPopupState} from "../../../actions/A_Popups";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import {getReferralPrograms} from "../../PageLayout/Popups/ReferralPopup/referralPopupApi";
import JobAssociateFabricatorPopupContentList from "./JobAssociateFabricatorPopupContentList";
import {getParsedJobOrder} from "../jobPurchaseOrderPopup/jobOrderFunctions";


const JobAssociateFabricatorPopupContent = (props) => {

  const {intl} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const handleInputChange = async (event) => {
    uiPopupDispatch({searchText: event.target.value})
  }

  const fabricatorsRequest = async () => {
    const response = await getReferralPrograms(uiPopupContext.job.fabricatorId);
    const jobOrder = getParsedJobOrder(uiPopupContext.job);
    uiPopupDispatch({
      referralList: (response || []).filter(referral => referral.enabled),
      responseReceived: true,
      childFabricatorId: jobOrder.childFabricatorId || null,
    });
  }

  useEffect(() => {
    fabricatorsRequest();
  }, []);

  // console.log("uiPopupContext", uiPopupContext);

  return (
    <div className="pl-1 pt-1 pr-075 flex-item mr-075 flex flex--column">
      <input className="fabricators-popup-search__input mb-05 fabricators-popup-search__input--small"
             placeholder={intl.formatMessage({id: "assignPopup.searchPlaceholder"})}
             value={uiPopupContext.searchText || ""}
             onChange={handleInputChange}/>
      <div className="flex-item relative">
        {!uiPopupContext.responseReceived
          ? <div className="ui-loader ui-loader--medium"/>
          : <JobAssociateFabricatorPopupContentList/>}
      </div>
    </div>
  )
};

const mapStateToProps = () => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
  };
};

const mapDispatchToProps = {
  setUiPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobAssociateFabricatorPopupContent)
)
